/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * Gizmo event Types
 */
export var GizmoEventType;
(function (GizmoEventType) {
    GizmoEventType[GizmoEventType["SELECTED"] = 0] = "SELECTED";
    GizmoEventType[GizmoEventType["DESELECTED"] = 1] = "DESELECTED";
    GizmoEventType[GizmoEventType["ACTIVATED"] = 2] = "ACTIVATED";
    GizmoEventType[GizmoEventType["DEACTIVATED"] = 3] = "DEACTIVATED";
    GizmoEventType[GizmoEventType["TRANSFORMED"] = 4] = "TRANSFORMED";
    GizmoEventType[GizmoEventType["REJECTED"] = 5] = "REJECTED";
})(GizmoEventType || (GizmoEventType = {}));
//# sourceMappingURL=GizmoEventType.js.map